export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    $('input[type="radio"].form-check-input').on('click', (e)=>{
      const form = $(e.currentTarget).parents('form:first');
      form.submit();
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/archive-blog.js